export const environment = {
    production: true,
    "path": "/keno",
    "api": "/Api",
    endpoint: ''
};



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/environments/environment.ts